import React from 'react';

import { Text } from '@change/ds-core-ui';

export type Signer = {
	user?: { id?: string; displayName?: string } | null;
	createdAtRelativeLocalized: string;
};

const renderSignerItem = (signer: Signer, index: number, qaId?: string, keySuffix?: string) => (
	<div
		key={`${signer.user?.id ?? index}-${index}${keySuffix ?? ''}`}
		className="shrink-0 pt-2 pr-[11px] pb-4 pl-[11px] whitespace-nowrap"
		data-qa={qaId ? `${qaId}-item` : undefined}
	>
		<Text variant="body" size="x-small" className="font-light text-[#403A49]">
			{signer.user?.displayName || 'Anonymous'}
			{' • '}
			{signer.createdAtRelativeLocalized}
		</Text>
	</div>
);

export type SignersCarouselProps = {
	signers: readonly Signer[];
	testId?: string;
	qaId?: string;
};

export const SignersCarousel: React.FC<SignersCarouselProps> = ({ signers, testId, qaId }) => {
	if (signers.length === 0) {
		return <div className="flex w-full flex-row items-start overflow-x-hidden" data-testid={testId} data-qa={qaId} />;
	}

	return (
		<div
			className="group flex w-full max-w-full min-w-0 flex-row items-start overflow-x-hidden"
			data-testid={testId}
			data-qa={qaId}
		>
			<div
				className="animate-signers-carousel group-hover:paused flex shrink-0 flex-row items-start"
				style={{ width: 'max-content' }}
			>
				{signers.map((signer, index) => renderSignerItem(signer, index, qaId))}
				<div aria-hidden="true" className="flex shrink-0 flex-row items-start">
					{signers.map((signer, index) => renderSignerItem(signer, index, qaId, '-clone'))}
				</div>
			</div>
		</div>
	);
};
